/*
TODO:  this content should really be loaded from an external source (Sanity or other).
*/
import type { Post } from 'common/lib/posts/types';

const referralsWhatsNewPost: Post = {
  title: `Amazon sync and our enhanced referral program!`,
  cta: 'Learn more',
  content: [
    {
      type: 'image',
      url: 'https://monarch-static-assets.s3.us-east-1.amazonaws.com/posts/referrals/chrome-extension.gif',
      darkModeUrl:
        'https://monarch-static-assets.s3.us-east-1.amazonaws.com/posts/referrals/chrome-extension-dark.gif',
    },
    {
      type: 'h1',
      text: `Your Amazon orders, perfectly categorized`,
    },
    {
      type: 'p',
      text: `The new Monarch Extension is here to bring you smarter categorization of your Amazon shopping trips, automatically.`,
    },
    {
      type: 'cta',
      text: 'Learn more',
      href: 'https://www.monarchmoney.com/blog/monarch-extension-and-more',
    },
    {
      type: 'image',
      url: 'https://monarch-static-assets.s3.us-east-1.amazonaws.com/posts/referrals/ticket-gift-card.png',
      darkModeUrl:
        'https://monarch-static-assets.s3.us-east-1.amazonaws.com/posts/referrals/ticket-gift-card-dark.png',
    },
    {
      type: 'badge',
      text: `Limited Time`,
      color: 'orange',
    },
    {
      type: 'h1',
      text: `Give and get more when you refer`,
    },
    {
      type: 'p',
      text: `Know someone who would love Monarch? Gift a friend **50% off their first year** and we'll gift you a **$50 gift card** as a thank you when they subscribe.`,
    },
    {
      id: 'navigateToReferrals',
      type: 'cta',
      text: `Learn more`,
    },
  ],
};

export default referralsWhatsNewPost;
